import React, { useCallback } from 'react';
import { useLocalSearchParams, useRouter } from 'expo-router';

import { useReorderNavigation } from '../../hooks/useReorderNavigation';
import { Customization } from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationScreen = () => {
  const router = useRouter();
  const routeParams = useLocalSearchParams<CustomizationScreenRouteParams>();

  const {
    restaurantSlug,
    productSlug,
    reorderLineItemId,
    sharedLineItemId,
    sharedLineItemSlug,
    unavailableIngModal,
  } = routeParams;

  const { finishReorder } = useReorderNavigation();

  // ─── Helpers ─────────────────────────────────────────────────────────

  const handleAddLineItemToCart = useCallback(() => {
    if (sharedLineItemId) {
      finishReorder(restaurantSlug);
      return;
    }

    router.replace({ pathname: '/bag', params: { referrer: 'Menu' } });
  }, [finishReorder, restaurantSlug, router, sharedLineItemId]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <Customization
      restaurantSlug={restaurantSlug}
      productSlug={productSlug}
      onAddLineItemToCart={handleAddLineItemToCart}
      reorderLineItemId={reorderLineItemId}
      sharedLineItemId={sharedLineItemId}
      sharedLineItemSlug={sharedLineItemSlug}
      shouldShowUnavailableIngredientsModal={unavailableIngModal !== 'false'}
      isEditProductMode={false}
    />
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type CustomizationScreenRouteParams = {
  restaurantSlug: string;
  productSlug: string;
  reorderLineItemId?: string;
  sharedLineItemId?: string;
  sharedLineItemSlug?: string;
  unavailableIngModal?: string;
};
